import { ReactElement } from "react";
import { FormattedText, Typography } from "client/Components";
import { CommunityNotificationDataViewModel } from "client/Api/Notifications/notifications";
import { setTrackingId } from "client/Misc/utils";
import { prepareHubItemTitle } from "./AnnouncementActivity";
import { localize } from "client_legacy/ndaw/culture";
import { CommunityVisibility } from "client/Api/Communities/community";

export type CommunityActivityProps = {
	data: CommunityNotificationDataViewModel;
};

export const CommunityActivity = (props: CommunityActivityProps): ReactElement => {
	const { data } = props;
	const {
		name: communityName,
		visibility
	} = data;

	return (
		<span {...setTrackingId("title")}>
			<FormattedText
				text={localize(visibilityToTitleKeyMap[visibility])}
				thingsToReplace={[
					{
						what: "{{Title}}",
						filler: (
							<Typography
								trackingId="community-name"
								weight="bold"
							>
								{prepareHubItemTitle(communityName)}
							</Typography>
						)
					}
				]}
			/>
		</span>
	);
};

CommunityActivity.displayName = "CommunityActivity";

const visibilityToTitleKeyMap: Record<CommunityVisibility, LocalizationKey> = {
	[CommunityVisibility.Public]: "_NewCommunityTitle",
	[CommunityVisibility.Private]: "_NewPrivateCommunityTitle",
	[CommunityVisibility.Hidden]: "_NewHiddenCommunityTitle"
};
